




















import { defineComponent, PropType } from "@vue/composition-api";
import Heading from "@/components/Atoms/Typography/Heading/index.vue";

export interface Props {
  heading: string;
  subHeading: string;
  level: string;
}

export default defineComponent({
  name: "Section",
  components: {
    Heading
  },
  props: {
    heading: {
      type: String as PropType<Props["heading"]>,
      required: true
    },
    subHeading: {
      type: String as PropType<Props["subHeading"]>,
      default: ""
    },
    level: {
      type: String as PropType<Props["level"]>,
      default: "1"
    }
  }
});
